import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class CampanhaService extends BaseService {
  constructor() {
    super(`${ConfigApi.campanhaURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.descricao = '';
    this.inativo = false;

    this.resumo = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new CampanhaService();
